import gql from 'graphql-tag';
import { Trend360FullFragment } from '../fragments/Trend360FullFragment';

export const Trend360CreateMutation = gql`
	mutation Trend360CreateMutation($values: Trend360CreateInput!) {
		results: trend360Create(values: $values) {
			...Trend360FullFragment
		}
	}
	${Trend360FullFragment}
`;